<script lang="ts">
    import { getContext, onDestroy, onMount } from "svelte";
    import type { Fn } from "../../global";

    const registerSlide: Fn = getContext('registerSlide');
    const unregisterSlide: Fn = getContext('unregisterSlide');

    let slideElement: HTMLElement;
    
    export let index: any = undefined;

    $: registerSlideIndex(index);

    onMount(() => registerSlideIndex(index));
    onDestroy(unregisterSlideIndex);

    function registerSlideIndex(index: any) {
        if (!slideElement) {
            return;
        }
        if (index !== undefined) {
            registerSlide(index, slideElement);
        } else {
            unregisterSlideIndex();
        }
    }

    function unregisterSlideIndex() {
        if (!slideElement) {
            return;
        }
        unregisterSlide(index);
    }

</script>

<style lang="scss">

    .swiper-slide {
        height: 100% !important;
        box-sizing: border-box;
    }

</style>

<div class="swiper-slide" bind:this={slideElement}>
    <slot></slot>    
</div>
